<template>
  <el-dialog title="Finish Review" :close-on-click-modal="false" :visible.sync="visible" width="700px" top="3vh">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-width="130px">
      <el-form-item label="Status" prop="status">
        <el-radio-group v-model="dataForm.status">
          <span v-for="item in clientCodeStatusList" :key="`review${item.title}`">
            <el-radio :label="item.value" v-if="item.value == 1 || item.value == 2" class="mr40">{{ item.title }}</el-radio>
          </span>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="Remark" prop="auditRemark">
        <el-input v-model="dataForm.auditRemark" type="textarea" :rows="5" :autosize="{ minRows: 4 }" resize="none" placeholder="Remark"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      visible: false,
      client: {},
      dataForm: {
        status: 1,
        auditRemark: "",
      },
      dataRule: {
        status: [{ required: true, message: "please select", trigger: "submit" }],
      },
      submitLoading: false,
    };
  },
  computed: {
    ...mapState("constant", ["clientCodeStatusList"]),
  },
  methods: {
    // 初始化
    async init(row) {
      this.submitLoading = false;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      const rowCopy = JSON.parse(JSON.stringify(row));
      this.client = rowCopy;
      this.dataForm = {
        status: 1,
        auditRemark: "",
      };
    },
    // 表单提交
    dataFormSubmit() {
      const dataForm = this.dataForm;
      const client = this.client;
      if (dataForm.status == 1) {
        if (!client.clientCode || !client.uen || !client.country) {
          this.$message.warning("Information for client code (e.g. UEN and/or Country) is not complete, please fill before reviewing.");
          return;
        }
      }
      this.$refs["dataForm"].validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .post(`/admin/clientCodeInfoManage/${this.client.id}/audit`, this.dataForm)
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshStatus");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
